import { useDispatch, useSelector } from "react-redux";
import { getBurnTimeReports } from "../../../store/slices/fault-module/burn-time-report.slice";
import BurnTimeReportTableComponent from "./burn-time-report-table.component";

const BurnTimeReportComponent = () => {
  const dispatch = useDispatch();

  const reportData = useSelector((state: any) => {
    return state.burnTimeReport.burnTimeReports;
  });

  const isLoadingBurnTimeReports = useSelector((state: any) => {
    return state.burnTimeReport.isLoadingBurnTimeReports;
  });

  const onRefetchData = (
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    asset = null
  ) => {
    dispatch(
      getBurnTimeReports({
        tcCode,
        siteCode,
        blockCode,
        reportType,
        startDate,
        endDate,
        asset,
      })
    );
  };

  return (
    <div>
      <BurnTimeReportTableComponent
        reportData={reportData}
        onRefetchData={onRefetchData}
        isLoading={isLoadingBurnTimeReports}
      />
    </div>
  );
};
export default BurnTimeReportComponent;
